import { render, staticRenderFns } from "./drawer.vue?vue&type=template&id=37f4d3aa&scoped=true&"
import script from "./drawer.vue?vue&type=script&lang=js&"
export * from "./drawer.vue?vue&type=script&lang=js&"
import style0 from "./drawer.vue?vue&type=style&index=0&id=37f4d3aa&lang=less&scoped=true&"
import style1 from "./drawer.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f4d3aa",
  null
  
)

export default component.exports